var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSpinner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    className: "spinner",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    r: 43,
    stroke: "#50b2fc",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "none",
    r: 43,
    stroke: "#a7d8fd",
    strokeWidth: 7,
    strokeLinecap: "square",
    transform: "rotate(27.6965 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;180 50 50;720 50 50",
    keyTimes: "0;0.5;1",
    dur: "2.5s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "linear",
    values: "9.42477796076938 179.0707812546182;188.4955592153876 -2.842170943040401e-14;9.42477796076938 179.0707812546182",
    keyTimes: "0;0.5;1",
    dur: 2.5,
    begin: "0s",
    repeatCount: "indefinite"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-spinner.8dc4004f7caa731b0929866adea2fb16.svg";